class SettlementConfigurationGroupModelConsts {
  public static readonly NameMaxLength: number = 100;

  public static readonly DescriptionMaxLength: number = 255;
}

export default SettlementConfigurationGroupModelConsts;
